export const dateTimeFormats = {
  short: {
    month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric'
  },
  medium: {
    year: 'numeric', month: 'short', day: 'numeric'
  },
  long: {
    year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric'
  },
  full: {
    year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric'
  }
};

export const messages = {
    "login.form.title": "Anmelden",
    "login.form.hint.user": "Anmeldename",
    "login.form.hint.password": "Kennwort",
    "login.form.checkbox.remember-me": "Erinnern Sie mich",
    "login.form.button.sign-in": "Anmelden",
    "login.form.message.invalid-user-credentials": "Der Anmeldename oder das Kennwort ist falsch",
    "login.form.message.user-required": "Geben Sie einen Anmeldenamen ein",
    "login.form.message.password-required": "Geben Sie ein Kennwort ein",
    "login.form.button.forgot-password": "Kennwort vergessen?",
    "error.root-admin-login.title": "Fehler 403 – verboten",
    "error.root-admin-login.message": "Sie sind als Nur-Lesen-Administrator angemeldet. Um auf die Web Recovery-Konsole zugreifen zu können, müssen Sie sich als Benutzer oder Administrator eines Kunden-Mandanten anmelden."
};
